import { BaseFooter } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";
import { FOOTER_LINKS } from "@/lib/constants";

export function AppFooter() {
  const { t } = useTranslation();

  return (
    <BaseFooter
      copyrightString={t("footer.copyright", { year: new Date().getFullYear() })}
      links={[
        { label: t("footer.contact"), href: FOOTER_LINKS.contact, external: true },
        { label: t("footer.support"), href: FOOTER_LINKS.support, external: true },
        { label: t("footer.privacy"), href: FOOTER_LINKS.privacy, external: true },
        { label: t("footer.terms"), href: FOOTER_LINKS.terms, external: true },
      ]}
    />
  );
}
